import type { FC } from 'react';

import CrehanaLogo from '@crehana/icons/logos/CrehanaLogo';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Container } from '@crehana/ui';

interface HeaderProps {
  isTransparent?: boolean;
  onGoBack: () => void;
}

const Header: FC<React.PropsWithChildren<HeaderProps>> = ({
  isTransparent = false,
  onGoBack,
}) => {
  return (
    <div className={!isTransparent ? 'bg-base-main' : ''} data-testid="header">
      <Container className="py-32">
        <div className="flex sm:justify-start">
          <button
            type="button"
            onClick={() => onGoBack()}
            className="flex flex-col items-center"
            data-testid="go-back-button"
          >
            <CrehanaLogo
              ignoreColor
              className="fill-current text-white"
              size={24}
            />
          </button>
        </div>
      </Container>
    </div>
  );
};

export default Header;
